<template>
  <div>

    <v-row>
      <v-col>
        <CurrentStockSearchForm
          :articles="currentStock.articles"
          @update-filter="updateFilter"
          @submit="search"
          @print="print"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  Artikel
                </th>
                <th>
                  Količina
                </th>
                <th>
                  ME
                </th>
                <th>
                  ZNC
                </th>
                <th>
                  PNC
                </th>
                <th>
                  PC
                </th>
                <th>
                  PC (neto)
                </th>
                <th>
                  Vrednost po ZNC
                </th>
                <th>
                  Vrednost po PNC
                </th>
                <th>
                  Skupina
                </th>
                <th>
                  Vrednost po PC
                </th>
                <th>
                  Vrednost po PC (neto)
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="asyncDataStatus_ready">
              <tr
                class="article-row"
                v-for="articleCurrentStock in currentStockFiltered"
                :key="articleCurrentStock.article"
              >
                <td>{{articleCurrentStock.article_name}}</td>
                <td>{{articleCurrentStock.quantity}}</td>
                <td>{{articleCurrentStock.purchase_measurement_unit_name}}</td>
                <td>{{articleCurrentStock.latest_purchase_price | price(2)}}</td>
                <td>{{articleCurrentStock.average_purchase_price | price(2)}}</td>
                <td>{{articleCurrentStock.latest_sell_price | price(2)}}</td>
                <td>{{articleCurrentStock.latest_netto_sell_price | price(2)}}</td>
                <td>{{articleCurrentStock.amount_latest_purchase_price | price(2)}}</td>
                <td>{{articleCurrentStock.amount_average_purchase_price | price(2)}}</td>
                <td>{{articleCurrentStock.category_name}}</td>
                <td>{{articleCurrentStock.amount_latest_sell_price | price(2)}}</td>
                <td>{{articleCurrentStock.amount_latest_netto_sell_price | price(2)}}</td>
                <td>
                  <ButtonActionDetails @click="openArticleCard(articleCurrentStock.article)" />
                </td>
              </tr>
              <tr v-if="currentStock.total_amount_latest_purchase_price && asyncDataStatus_ready">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td><b>{{currentStock.total_amount_latest_purchase_price | price(2)}}</b></td>
                <td><b>{{currentStock.total_amount_average_purchase_price | price(2)}}</b></td>
                <td></td>
                <td><b>{{currentStock.total_amount_latest_sell_price | price(2)}}</b></td>
                <td><b>{{currentStock.total_amount_latest_netto_sell_price | price(2)}}</b></td>
                <td></td>
              </tr>
            </tbody>
            <tbody v-else>
              <div style="position: absolute; width: 100%;">
                <AppSpinner />
              </div>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <PopupArticleCard
      ref="popupArticleCard"
      :articleId="popupArticleCardArticle"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import { siIncludes } from '@/utils/str'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import AppSpinner from '../components/AppSpinner'
import CurrentStockSearchForm from '@/components/CurrentStockSearchForm'
import ButtonActionDetails from '@/components/ButtonActionDetails'
import PopupArticleCard from '@/components/PopupArticleCard'

export default {
  components: {
    CurrentStockSearchForm,
    ButtonActionDetails,
    PopupArticleCard,
    AppSpinner,
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      currentStock: [],
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null,
      popupArticleCardArticle: null
    }
  },
  computed: {
    currentStockFiltered () {
      if (this.filter.length) {
        return  this.currentStock.articles.filter(item => {
          return siIncludes({ haystack: `${item.article_name}`, needle: this.filter })
        })
      }
      return this.currentStock.articles
    }
  },
  methods: {
    ...mapActions('currentStock', ['loadItems']),
    updateFilter (val) {
      this.filter = val
    },
    search (form) {
      const filters = {}
      if (form.endDate) {
        filters.dateTo = form.endDate
      }
      if (form.selectedCategoryIds && form.selectedCategoryIds.length && !form.selectedCategoryIds.includes(null)) {
        filters.categories = form.selectedCategoryIds.join(',')
      }
      if (form.currentStockOption) {
        filters.includeSellDataType = form.currentStockOption
      }
      this.asyncDataStatus_ready = false;
      this.doLoadItems(filters)
        .then(() => {
          this.asyncDataStatus_fetched()
        })
    },
    print (form) {
      const filters = {
        dateTo: form.endDate,
        reportType: form.reportType
      }
      if (form.selectedCategoryIds && form.selectedCategoryIds.length && !form.selectedCategoryIds.includes(null)) {
        filters.categories = form.selectedCategoryIds.join(',')
      }
      if (form.currentStockOption) {
        filters.includeSellDataType = form.currentStockOption
      }

      let routeData = this.$router.resolve({ name: 'MyCompanyCurrentStockPreview', query: filters })
      window.open(routeData.href, '_blank')
    },
    doLoadItems (filters) {
      return new Promise((resolve, reject) => {
        this.loadItems({ filters })
          .then(res => {
            this.currentStock = objectToArray(res)[0]
            this.currentStock.articles = this.currentStock.articles.sort((a, b) => a.category_name < b.category_name ? -1 : 1)
            resolve()
          })
      })
    },
    openArticleCard (article) {
      this.popupArticleCardArticle = article
      this.$refs.popupArticleCard.open()
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      // this.asyncDataStatus_fetched()
    }
  }
}
</script>
